import PropTypes from 'prop-types';
import React, { useMemo, useEffect } from 'react';

import { transactionsTypes } from 'app-components/flux/transactions';

import QAmountField from 'components/QAmountField';

import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';

const InvestmentTransactionAmountForm = (props) => {
  const { formik } = props;

  useEffect(() => {
    formik.registerField('amount', {
      validate: (value) => (typeof value === 'number' && Number(value) !== 0 ? undefined : 'use valid number'),
    });
    return () => {
      formik.unregisterField('amount');
    };
  }, [formik]);

  const { label, expectedSign } = useMemo(() => {
    let newLabel;
    let newExpectedSign;
    switch (formik.values.investmentTxnType) {
      case transactionsTypes.InvestmentTxnType.INCOME_DIVIDEND:
        newLabel = 'Dividend';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.INCOME_INTEREST:
        newLabel = 'Interest';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.CAPITAL_GAIN_LONG:
      case transactionsTypes.InvestmentTxnType.CAPITAL_GAIN_SHORT:
        newLabel = 'Distribution Amount';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.INCOME_MISCELLANEOUS:
        newLabel = 'Amount';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.EXPENSE_MARGIN_INTEREST:
        newLabel = 'Interest paid';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.EXPENSE_MISCELLANEOUS:
        newLabel = 'Amount';
        break;
      case transactionsTypes.InvestmentTxnType.RETURN_OF_CAPITAL:
        newLabel = 'Amount returned';
        newExpectedSign = 'positive';
        break;
      case transactionsTypes.InvestmentTxnType.UNKNOWN:
      case 'VIRTUAL_CASH_FLOW':
        newLabel = 'Total amount';
        break;
      default:
        newLabel = 'Amount';
        assert(!formik.values.investmentTxnType, `unexpected investmentTxnType = ${formik.values.investmentTxnType}`);
    }
    return { label: newLabel, expectedSign: newExpectedSign };
  }, [formik.values.investmentTxnType]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <QAmountField
        id='amount'
        editable
        label={label}
        sx={{ minWidth: 110 }}
        expectedSign={expectedSign}
        noNegatives
        value={Math.abs(formik.values.amount)}
        onChange={(event) => formik.setFieldValue('amount', Number(event.target.value))}
        error={Boolean(formik.submitCount > 0 && formik.errors.amount)}
        helperText={(formik.submitCount > 0 && formik.errors.amount) || ''}
      />
    </>
  );
};

InvestmentTransactionAmountForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default InvestmentTransactionAmountForm;
